import { Button, Dialog, IconButton, Tooltip, makeStyles, Typography, withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { CommonConfig } from '../../../config/common-config';
import { Document, Page, pdfjs } from 'react-pdf';
import PreviewModal from '../../../components/modal/previewModal';
import PreviewImage from '../../../assets/previewImage.png';
import downloadImage from '../../../assets/downloadImage.png';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    //console.log(props );
    //console.log(onClose);
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6" style={{ fontFamily: 'rubik' }}>
                {children}
            </Typography>
            <Typography variant="subtitle1" style={{ fontFamily: 'rubik' }}>
                Preview
            </Typography>
            {onClose ? (
                // <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                //     <CloseIcon />
                // </IconButton>
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        overflowX: 'clip',
        ['@media (max-width:600px)']: {
            overflowX: 'auto',
        },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minHeight: '100vh',
        maxHeight: '100vh',
    },
    actionDisplay: {
        display: 'contents',
    },
    btn: {
        color: 'white !important',
        // padding: '4px 20px',
        fontSize: '14px !important',
        background: '#3f51b5 !important',
        fontFamily: 'Rubik',
        fontWeight: '400 !important',
        borderRadius: '6px',
        letterSpacing: 'normal',
        textTransform: 'capitalize',
        cursor: 'pointer',
        margin: '5px !important',
        // '&:hover': {
        //     background: 'hsl(33deg 94% 54%)',
        // },
    },
    center: {
        textAlign: 'center',
    },
    textArea: {
        display: 'inline-flex',
        resize: 'none',
        marginLeft: '60px',
    },
    textarea1: {
        marginRight: '60px',
        resize: 'none',
    },
    textarea2: {
        marginLeft: '50px',
        resize: 'none',
    },
}));

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const Preview = ({ mode, Icon, post, row }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page
    const downloadPath = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${row.invoiceUrl}`;

    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber((prevPageNumber) => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    ////console.log('ICON' ,Icon );
    //console.log(mode , 'mode')
    return (
        <>
            {Icon === 'preview' && (
                // <Tooltip title={mode} onClick={handleClickOpen}>
                //     <IconButton aria-label={mode}>
                //         {/* <Icon /> */}
                //         <VisibilityIcon />
                //     </IconButton>
                // </Tooltip>
                <span onClick={handleClickOpen}>
                    <Tooltip title="Preview">
                        <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                    </Tooltip>
                </span>
            )}

            <Dialog className={classes.dialogPaper} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    TAX INVOICE
                </DialogTitle>
                {open === true && post === 'superAdmin' && (
                    // && ////console.log('Preview  Option is Clicked for SuperAdmin', row)
                    <DialogContent>
                        <Document file={downloadPath} options={{ workerSrc: '/pdf.worker.js' }} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={pageNumber} />
                        </Document>
                    </DialogContent>
                )}
                {open === true && post === 'admin' && (
                    // && ////console.log('Preview  Option is Clicked for Admin', row)
                    <DialogContent>
                        <Document file={downloadPath} options={{ workerSrc: '/pdf.worker.js' }} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={pageNumber} />
                        </Document>
                    </DialogContent>
                )}
                <DialogActions>
                    {/* <div className={classes.actionDisplay}>
                        <p>
                            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                        </p>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.btn}
                            disabled={pageNumber <= 1}
                            onClick={previousPage}
                        >
                            Previous
                        </Button>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.btn}
                            disabled={pageNumber >= numPages}
                            onClick={nextPage}
                        >
                            Next
                        </Button>
                    </div> */}
                </DialogActions>
            </Dialog>
        </>
    );
};

export const Download = ({ mode, Icon, post, row }) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        //console.log('row', row);
        const downloadPath = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${row.invoiceUrl}`;
        window.location.href = downloadPath;
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {Icon === 'download' && (
                // <Tooltip title={Icon} onClick={handleClickOpen}>
                //     <IconButton aria-label={Icon}>
                //         {/* <Icon /> */}
                //         <GetAppIcon />
                //     </IconButton>
                // </Tooltip>
                <span style={{ marginTop: '-4px', marginRight: '6px' }} onClick={handleClickOpen}>
                    <Tooltip title="Download">
                        <img src={downloadImage} alt="downloadImage" className="downlaodImg downloadImgTop" />
                    </Tooltip>
                </span>
            )}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                {
                    open === true && post === 'superAdmin'
                    // && ////console.log('Download Option is Clicked for SuperAdmin', row)
                }
                {
                    open === true && post === 'admin'
                    // && ////console.log('Download Option is Clicked for Admin', row)
                }
                {
                    open === true && post === 'itec'
                    // && ////console.log('Download Option is Clicked for ITec', row)
                }
            </Dialog>
        </>
    );
};

// can Write both the logics here
